<div>
  <mat-accordion class="example-headers-align" multi>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title> {{langObj ? langObj?.MyFavoriteModule : ('MyFavoriteModule' | translate)}}</mat-panel-title>
      </mat-expansion-panel-header>

      <ul class="menu-card-landing-page-list" dir="{{languageDir}}">
        <li class="landing-list-items" *ngFor="let cardItem of sortedCards; let i = index">

          <a class="landing-list-link cursor-scroll" [ngClass]="{'disabled': cardItem.disabled}">

            <div class="landing-link-top-box" (click)="displayRightmenu(cardItem.menuId, cardItem.url, cardItem?.type, cardItem)"  [id]="cardItem?.menuId">
              <div class="landing-box-bg">
                <svg width="62" height="68" viewBox="0 0 62 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M25 2.4641C28.7128 0.320509 33.2872 0.320508 37 2.4641L55.3109 13.0359C59.0237 15.1795 61.3109 19.141 61.3109 23.4282V44.5718C61.3109 48.859 59.0237 52.8205 55.3109 54.9641L37 65.5359C33.2872 67.6795 28.7128 67.6795 25 65.5359L6.68911 54.9641C2.9763 52.8205 0.689112 48.859 0.689112 44.5718V23.4282C0.689112 19.141 2.9763 15.1795 6.68911 13.0359L25 2.4641Z"
                    fill="#242bf0" />
                </svg>
              </div>
              <div class="landing-top-icon">
                <img [src]="'assets/Content/Icon/' + cardItem.icon" alt="{{ cardItem.menuName }} Icon">
              </div>
            </div>
            <p  (click)="displayRightmenu(cardItem.menuId, cardItem.url, cardItem?.type, cardItem)"  [id]="cardItem?.menuId">
              <span class="landing-link-text">{{ cardItem.menuName }}</span>
            </p>

            <div class="action-buttons">
              <button class="btn-edit" (click)="onEdit(cardItem)">
                <i class="pi pi-pencil edit-icon"></i>
              </button>
              <button class="btn-delete" (click)="onDelete(cardItem)">
                <i class="pi pi-trash" style="color: red; font-size: 16px;"></i>
              </button>
            </div>
          </a>
        </li>
        <div class="no-data-container" *ngIf="!cards || cards.length === 0">
          <div class="no-data">
            <i class="fa fa-info-circle no-data-icon" aria-hidden="true"></i>
            <p class="no-data-message">
              No favorite features added. <br />
              Click on <strong>
                <a (click)="navigateToHome()">Home</a>
              </strong> and add your favorite features.
            </p>
          </div>
        </div>
      </ul>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title> {{langObj ? langObj?.Mytasks : ('Mytasks' | translate)}}</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="cards-container-info">
        <div class="card-column-info card-column-flexible">
          <mat-card>
            <mat-card-content>
              <!-- <div class="charts-info-container">
                <div [chart]="currentShiftOEE" class="chart-info"></div>
                <div [chart]="lastOEE" class="chart-info"></div>
                <div [chart]="YesterdayOEE" class="chart-info"></div>
            </div> -->

              <!-- <ag-grid-angular style="width: 100%; height: 10vw;" class="ag-theme-alpine" [columnDefs]="columnDefsProcessOrder"
                [gridOptions]="gridOptions" [enterMovesDown]="true" [enterMovesDownAfterEdit]="true"
                [rowData]="rowDataPO" (gridReady)="onGridReady($event)" [singleClickEdit]="true"
                [frameworkComponents]="frameworkComponents"
                 [pagination]="true"
                [paginationPageSize]="2"></ag-grid-angular> -->

              <span class="bottom-float"> <button mat-icon-button matTooltip="Add" (click)="openTaskPopup()"
                  aria-label="Example icon button with a vertical three dot icon">
                  <mat-icon class="o3Color-icon">note_add</mat-icon>
                </button></span>
              <ag-grid-angular style="width: 100%; height: 15vw;" class="ag-theme-alpine" [columnDefs]="columnDefsAM"
                [gridOptions]="gridOptions" [enterMovesDown]="true" [enterMovesDownAfterEdit]="true"
                [rowData]="rowDataAM" (gridReady)="onGridReadyTODO($event)" [singleClickEdit]="true"
                [frameworkComponents]="frameworkComponents" [pagination]="true"
                [paginationPageSize]="5"></ag-grid-angular>


              <ag-grid-angular style="width: 100%; height: 15vw;" class="ag-theme-alpine"
                [columnDefs]="columnDefsAction" [gridOptions]="gridOptions" [enterMovesDown]="true"
                [enterMovesDownAfterEdit]="true" [rowData]="rowDataAction" (gridReady)="onGridReady($event)"
                [singleClickEdit]="true" [frameworkComponents]="frameworkComponents" [pagination]="true"
                [paginationPageSize]="5"></ag-grid-angular>
            </mat-card-content>
          </mat-card>
        </div>
        <!-- <div class="card-column-info card-column-fixed">
          <mat-card>
            <div class="card-info">
              <img src="{{userDetail.picture}}" alt="User Profile" style="height:100px;width:100px">
              <h2>{{userDetail.UserName}}</h2>
              <p class="title">Department: {{department}}</p>
              <p>Plant : {{plant}}</p>
              <form [formGroup]="PersonalInfoform">
              
              <mat-form-field appearance="outline" class="top-row-first-filed-item top-row-filed-rem-item">
          
              <mat-select formControlName="ProdUnit" (selectionChange)="onChangeProdUnit($event)"
                placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}" panelClass="testClass" name="Status">
                <mat-select-filter [placeholder]="'Search'" [displayMember]="'puDesc'" [array]="userMachines"
                  (filteredReturn)="filteredUser = $event"></mat-select-filter>
                <mat-option *ngFor="let unit of filteredUser" [value]="unit.puId">
                  {{unit.puDesc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
           
            </form>
              <p><button class="button-info">Last Logged In : {{lastLoggedIn| date :'medium'}}</button></p>
            </div>
           
          
          </mat-card>
          <mat-card>
            <div class="card-info">
              <p><button class="button-info-special"><span class="blink_me">*Special Instructions*</span></button></p>
              <p style="margin: 3px;">1. Use Type 4 resin Only</p>
              <p style="margin: 3px;">2. Machine Speed not to increase above 15</p>
            </div>
           
          
          </mat-card>
        </div> -->
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <ng-template #AddTaskPoup>
    <div mat-dialog-title class="mat-title">
      <div class="d-flex justify-content-between align-items-center">
        <h1 *ngIf="!updateCard" class="main-title">{{langObj ? langObj?.addTask : ('addTask' | translate)}}</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div>
      <form [formGroup]="AddTaskform">
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field appearence="fill"
          class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <input matInput formControlName="taskName" panelClass="testClass" maxlength="250"
              placeholder="{{langObj ? langObj?.taskName : ('taskName' | translate)}}">
          </mat-form-field>
          <div class="inputField">
            <nz-date-picker class="calender-input" id="startPicker" formControlName="targetDate"
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzDisabledDate]="disabledDate" [nzInputReadOnly]="true"
              [required]="true"></nz-date-picker>
            <span class="floating-text" style="font-size: 15px;">{{langObj ? langObj?.TargetDate : ('TargetDate' |
              translate)}} *</span>
          </div>
          <mat-form-field appearence="fill"
          class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="status"
            placeholder="{{langObj ? langObj?.Status : ('Status' | translate)}}" panelClass="testClass"
            name="Status">
            <mat-option value="open">Open</mat-option>
            <mat-option value="inprogress">InProgress</mat-option>
            <mat-option value="closed">Closed</mat-option>
          </mat-select>
         
        </mat-form-field>
        </div>
        <div>
          <div class="content-top-row" style="height: auto;">
            <mat-form-field appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="width: 100%; margin-left: 10px;">
              <textarea formControlName="taskDescription" panelClass="testClass" maxlength="1000"
                placeholder="{{langObj ? langObj?.taskDescription : ('taskDescription' | translate)}}"
                matInput></textarea>
            </mat-form-field>
          
          </div>
          <button mat-mini-fab color="primary" type="submit" *ngIf="!IsEdit" 
            (click)="addTask()">
            <mat-icon style="color: #fff">save</mat-icon>
          </button>
          <button mat-mini-fab color="primary" type="submit" *ngIf="IsEdit"
          (click)="updateTask()">
          <mat-icon style="color: #fff">edit</mat-icon>
        </button>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template #AddFavPoup>
    <div mat-dialog-title class="mat-title">
      <div class="d-flex justify-content-between align-items-center">
        <h1 *ngIf="!updateCard" class="main-title">{{langObj ? langObj?.UpdateFavourite : ('UpdateFavourite' | translate)}}</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div>
      <form [formGroup]="AddFavform">
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <input matInput formControlName="menuName" maxlength="150"
              placeholder="{{langObj ? langObj?.menuName : ('menuName' | translate)}}">
          </mat-form-field>

          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <input matInput formControlName="order" type="number" (input)="checkMaxDigitsWithDecimal($event)"  
              placeholder="{{langObj ? langObj?.order : ('order' | translate)}}">
          </mat-form-field>
    
          <button mat-mini-fab color="primary" type="submit"
          (click)="updateMenu()">
          <mat-icon style="color: #fff">edit</mat-icon>
        </button>
        </div>
      
      </form>
    </div>
  </ng-template>

</div>